import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface UIState {
  // Sidebar state: expanded with labels unless the user collapsed it to icons
  sidebarCollapsed: boolean;

  // Theme state
  themeMode: 'light' | 'dark';

  // Actions
  toggleSidebar: () => void;
  toggleTheme: () => void;
  setThemeMode: (mode: 'light' | 'dark') => void;
}

export const useUIStore = create<UIState>()(
  persist(
    (set) => ({
      // Initial state
      sidebarCollapsed: false,
      themeMode: 'light',

      // Actions
      toggleSidebar: () => set((state) => ({ sidebarCollapsed: !state.sidebarCollapsed })),
      toggleTheme: () =>
        set((state) => ({
          themeMode: state.themeMode === 'light' ? 'dark' : 'light',
        })),
      setThemeMode: (mode) => set({ themeMode: mode }),
    }),
    {
      name: 'diggens-ui-store',
      partialize: (state) => ({
        sidebarCollapsed: state.sidebarCollapsed,
        themeMode: state.themeMode,
      }),
    }
  )
);
